// Directus `blog_posts.tags` is a single free-text array that carries two
// unrelated things: real topical tags, and render-control flags the site reads
// as feature switches. There is no marker column separating them, so the
// control flags are enumerated here and stripped before tags reach anything
// user- or machine-facing (schema.org `keywords`, the `keywords` meta tag).
//
// Add a tag here whenever a new control flag is introduced in Directus.
// Known consumers of the control flags:
//   - "hero-blur" -> components/blog/blog-post-hero.tsx (softens the cover image)
export const INTERNAL_BLOG_TAGS: readonly string[] = ["hero-blur"]

const INTERNAL_TAG_SET = new Set(INTERNAL_BLOG_TAGS.map((t) => t.toLowerCase()))

export function isInternalBlogTag(tag: string): boolean {
  return INTERNAL_TAG_SET.has(tag.trim().toLowerCase())
}

/** Drop render-control flags and blanks from a Directus tag array. */
export function filterInternalBlogTags(
  tags: string[] | null | undefined
): string[] {
  if (!Array.isArray(tags)) return []
  return tags.filter((tag) => typeof tag === "string" && tag.trim() !== "" && !isInternalBlogTag(tag))
}
